import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { AppBar, makeStyles, Tab, Tabs } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { useSelector } from 'react-redux';

import { AnnouncersTable } from '../tables/announcersTable/AnnouncersTable';
import PointsTableContainer from '../tables/pointsTable/PointsTableContainer';


const TabPanel = (props) =>{
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}


TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
}));


export const TabTables = () => {
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const {announcer} = useSelector(state => state.auth.valitadion)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <AppBar color="default"  position="static">
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    variant="fullWidth"
                    indicatorColor="primary" 
                    textColor="primary" 
                    centered
                >
                    <Tab  label="TWS" icon={<LocationOnIcon />} {...a11yProps(0)}/>
                    {announcer === 'True' &&
                        <Tab  label="Anunciadores" icon={<ArrowDropDownIcon />} {...a11yProps(1)}/>
                    }
                    
                    
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <PointsTableContainer />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <AnnouncersTable/>
            </TabPanel>
            
        </div>
    )
}
